Vue.asyncComponent('ak-collapsible', {
    data() {
        return {
            collapsedLocal: true
        }
    },
    props: {
        label: {
            type: String,
            required: true,
        },
        body: {
            type: String,
            required: true,
        },
        collapsed: {
            type: Boolean,
            default: true
        }
    },
    model: {
        prop: 'collapsed',
        event: 'toggle',
    },
    watch: {
        collapsedLocal() {
            if (this.collapsedLocal !== this.collapsed) {
                this.$emit('toggle', this.collapsedLocal);
            }
        },
        collapsed() {
            this.collapsedLocal = this.collapsed;
        }
    },
    methods: {
        /**
         * Toggle collapsed
         */
        toggleCollapsed() {
            this.collapsedLocal = ! this.collapsedLocal;
        }
    },
    mounted() {
        this.collapsedLocal = this.collapsed;
    }
}, 'layout/collapsible/ak-collapsible.html');